import { Component, OnDestroy, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ConfigService } from '../../../../services/config.service';
import { HeaderService } from '../../services/header.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header-alert-banner',
  templateUrl: './header-alert-banner.component.html',
  styleUrls: ['./header-alert-banner.component.scss'],
  animations: [
    trigger('fadeOut', [
      transition(':leave', [
        style({
          opacity: 1,
          overflow: 'hidden',
          transformOrigin: 'top',
          transform: 'scaleY(1)',
        }),
        animate('.20s ease-out', style({
          opacity: 0,
          transform: 'scaleY(0)',
        })),
      ]),
    ])
  ]
})
export class HeaderAlertBannerComponent implements OnDestroy, OnInit {
  private breakpointSubscription!: Subscription;

  readonly isEnabled$ = this.headerService.isAlertBannerEnabled$;
  ellipsisLineClamp = 1;
  message: string = '';

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly configService: ConfigService,
    private readonly headerService: HeaderService,
  ) { }

  ngOnInit(): void {
    this.breakpointSubscription = this.breakpointObserver.observe('(max-width: 768px)').subscribe(({  matches }) => {
      this.ellipsisLineClamp = !matches ? 1 : 2;
    });
    this.headerService.isAlertBannerEnabled$.next(Boolean(this.configService.get().malfunctionBannerMessage));
    this.message = this.configService.get().malfunctionBannerMessage;
  }

  ngOnDestroy() {
    this.breakpointSubscription.unsubscribe();
  }

  closeBanner() {
    this.headerService.isAlertBannerEnabled$.next(false);
  }
}
